import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import { Button, buttonBaseClasses, Drawer, styled } from '@mui/material';
import { IGap } from 'v3/shared/components/OnlineNavBar/types';

import { HeadlineSmall } from 'v3/shared/typography/HeadlineSmall';

export const paperStyle = { style: { display: 'flex', width: '100%' } };

export const DrawerStyled = styled(Drawer)(({ theme, open }) => ({
  zIndex: '999',

  '& .MuiDrawer-paper': {
    width: '100%',
    backgroundColor: theme.palette.primary.main,

    [theme.breakpoints.up('sm')]: {
      width: open ? '20rem' : '5rem',
    },
  },
}));

export const DrawerContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  padding: '1rem 1rem',

  [theme.breakpoints.up('xs')]: {
    paddingLeft: '.1rem',
  },
  [theme.breakpoints.up('md')]: {
    padding: '1rem',
  },
}));

export const AlignColumn = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '1.5rem',
}));

export const NavigationButtons = styled(Button)<{ active: boolean }>(({ active, theme }) => ({
  color: active ? theme.palette.common.white : theme.palette.secondary.light,
  backgroundColor: active ? theme.palette.primary.dark : '',
  padding: '1rem',
  borderRadius: '0.5rem',
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  gap: '0.5rem',
  cursor: 'pointer',
  textTransform: 'none',
  minWidth: 'fit-content',
  flexShrink: 0,

  [`&.${buttonBaseClasses.disabled}`]: {
    color: theme.palette.common.white,
    opacity: 0.4,
  },

  [theme.breakpoints.up('sm')]: {
    padding: '0rem 0.8rem',
    marginRight: '.19rem',
  },

  [theme.breakpoints.up('md')]: {
    margin: '0',
  },
}));

export const NavigationGroup = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  gap: '2rem',
  justifyContent: 'center',
  flexWrap: 'nowrap',

  [theme.breakpoints.up('xs')]: {
    gap: '0',
    position: 'relative',
    right: '1rem',
  },
}));

export const Gap = styled('div')<IGap>(({ gap }) => ({
  display: 'flex',
  gap: `${gap}rem`,
}));

export const ImgStyled = styled('img')(({ theme }) => ({
  width: '10rem',
  display: 'flex',
  [theme.breakpoints.up('md')]: {
    marginRight: '2.5rem',
  },
}));

export const CloseIconStyled = styled(ExitToAppIcon)(({ theme }) => ({
  alignSelf: 'flex-end',
  cursor: 'pointer',
}));

export const HeadlineSmallStyled = styled(HeadlineSmall)(({ theme }) => ({
  [theme.breakpoints.up('md')]: {
    display: 'none',
  },
}));
